import React from "react";
import { Aside } from "sprint-common-web";

import { EditAudioTechnicalInfoAsideContent } from "./EditAudioTechnicalAsideContent";

export interface EditAudioTechnicalAsideProps {
    fileRecordId: string;
    isOpen: boolean;
    onCancel(): void;
    onSubmit(): void;
}

export const EditAudioTechnicalAside: React.FC<EditAudioTechnicalAsideProps> = (
    props: EditAudioTechnicalAsideProps
) => {
    const { fileRecordId, isOpen, onSubmit, onCancel } = props;

    return (
        <Aside type="form" headerText="Edit technical info" isOpen={isOpen} onDismiss={onCancel} isLightDismiss={true}>
            <EditAudioTechnicalInfoAsideContent fileRecordId={fileRecordId} onCancel={onCancel} onSubmit={onSubmit} />
        </Aside>
    );
};
